<template>
  <div class="ftdiv bg-red twhite" :class="{sftdiv:isEnroll==1}">
    <div class="htmldiv">
      <div class="ldiv dinline-block vcenter">
        <div class="tdiv pt20 pb20">
          <a href="index.htm" class="vtop">
<!--            <img src="../assets/images/index_01_01.png">-->
          </a>
          <div class="txt dinline-block vtop lh16 ml45 mt5">
            <div class="sd dinline-block phone">
              <span class="mr30 dinline-block">{{info.telephones}}</span>
            </div>
<!--            <div class="sd dinline-block email mr30">{{info.header_master_email}}</div>-->
            <div class="sd address">{{info.school_address}}</div>
          </div>
        </div>
        <div class="andiv pt15 pb15 mat">
          <span class="mr30 ml10 fs14">版权所有：青田县华侨技工学校</span>
         <a href="https://beian.miit.gov.cn/" target="_blank"><span class="mr30 fs14" style="color:#fff">ICP备案号：浙ICP备2026028300号-1</span></a>
         <img src="../../static/images/gongan_logo.png" alt="" style="width:18px;height:18px;vertical-align:middle;" />
         <span class="mr30 fs14" style="color:#fff">浙公网安备 33112102000191号</span>
          <span class="mr30 fs14">建议使用IE10及以上版本浏览器浏览，推荐分辨率：1920*1080</span>
        </div>
      </div>
      <div class="wx fr vcenter">
        <div class="dinline-block tcenter mt25 mr10">
          <img src="../../static/images/gongzhong.jpg" alt="" width="90" height="90">
          <div class="mt5">官方公众号</div>
        </div>
<!--        <div class="dinline-block tcenter ">-->
<!--          <img src="../assets/images/vr.jpg" alt="" width="90" height="90">-->
<!--          <div class="mt5">VR二维码</div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  props:[
    'isEnroll'
  ],
  data(){
    return {
      info:{},
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      this.$request.get('bottom-config',[],response => {
        if(response.data.code == 200){
          this.info = response.data.data
        }
        console.log(this.info)
      },error => {
        console.log(error)
      })
    },
  }
}
</script>

<style scoped>
  .andiv{white-space: nowrap;}
  .ldiv{width: 1065px;}
  .ftdiv.sftdiv .htmldiv{width: 1200px;}
  .ftdiv.sftdiv .txt{width: 640px;}

</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue